import {
    ILanguagesContextState,
    LanguagesContextDispatchMessageType,
    TopicsContextDispatchMessage
} from "./LanguagesContext.interfaces";
import {ILanguage} from "../../Interfaces/Language";

export const initialState: ILanguagesContextState = {
    loaded: false,
    list: new Array<ILanguage>(),
}

export const reducer = (prevState: ILanguagesContextState, payloads: Array<TopicsContextDispatchMessage>): ILanguagesContextState => {
    const newState: ILanguagesContextState = {...prevState};
    payloads.forEach(payload => {
        const payloadType = payload.type;
        switch (payloadType) {
            case LanguagesContextDispatchMessageType.SetList:
                newState.list = payload.list;
                break;
            case LanguagesContextDispatchMessageType.SetLoaded:
                newState.loaded = payload.value;
                break;
            default:
                throw new Error("Message " + LanguagesContextDispatchMessageType[payloadType] + " not implemented");
        }
    });
    return newState;
}